module.exports = _.sample;